import { defineStore } from "pinia"

const CACHE_TTL_MS = 5 * 60 * 1000
const MAX_CACHED_PAGES = 10

type CachedPage = {
  rows: any[]
  hasMore: boolean
  cachedAt: number
}

export const useGefahrstoffePageCache = defineStore("gefahrstoffePageCache", {
  state: () => ({
    pages: {} as Record<string, CachedPage>,
  }),

  persist: typeof sessionStorage === "undefined" ? false : {
    storage: sessionStorage,
  },

  actions: {
    getFresh(key: string): CachedPage | null {
      const page = this.pages[key]
      if (!page) return null
      if (Date.now() - page.cachedAt > CACHE_TTL_MS) {
        delete this.pages[key]
        return null
      }
      return page
    },

    put(key: string, rows: any[], hasMore: boolean) {
      const now = Date.now()
      Object.entries(this.pages).forEach(([existingKey, page]) => {
        if (now - page.cachedAt > CACHE_TTL_MS) delete this.pages[existingKey]
      })
      this.pages[key] = {
        rows,
        hasMore,
        cachedAt: now,
      }
      Object.entries(this.pages)
        .sort(([, left], [, right]) => right.cachedAt - left.cachedAt)
        .slice(MAX_CACHED_PAGES)
        .forEach(([staleKey]) => delete this.pages[staleKey])
    },

    remove(key: string) {
      delete this.pages[key]
    },

    clear() {
      this.pages = {}
    },
  },
})
